import { action, makeObservable, observable } from 'mobx';

import { LaunchData, PreLobbyGame, PreLobbyGamesRequest } from '../models';
import { HttpResponse, lobbyController } from '../api';
import { GameModeName } from '../constants';
import { env } from '../environment';
import { RootStore } from '.';
import { markLaunchStep } from '../services/launch-telemetry';

export class LobbyStore {
  private rootStore?: RootStore;

  public isLobbyOpen = false;

  public isPreLobbyOpen = false;

  public preLobbyGamesResponse = new HttpResponse<Array<PreLobbyGame>>([]);

  constructor(rootStore?: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      isLobbyOpen: observable,
      setIsLobbyOpen: action.bound,

      isPreLobbyOpen: observable,
      setIsPreLobbyOpen: action.bound,

      preLobbyGamesResponse: observable,
      setPreLobbyGamesResponse: action.bound,

      resetPreLobbyGamesResponse: action.bound,
    });
  }

  public setIsLobbyOpen(value: boolean) {
    this.isLobbyOpen = value;
  }

  public setIsPreLobbyOpen(value: boolean) {
    this.isPreLobbyOpen = value;
  }

  public openPreLobbyOrLobby() {
    if (this.rootStore?.gameStore.launchData.data?.hasPreLobby) {
      this.setIsPreLobbyOpen(true);
    } else {
      this.setIsLobbyOpen(true);
    }
  }

  public setPreLobbyGamesResponse(value: HttpResponse<Array<PreLobbyGame>>) {
    this.preLobbyGamesResponse = value;
  }

  public resetPreLobbyGamesResponse() {
    this.setPreLobbyGamesResponse(this.preLobbyGamesResponse.fetched([]));
  }

  public async getPreLobbyGames(value: PreLobbyGamesRequest): Promise<void> {
    this.setPreLobbyGamesResponse(this.preLobbyGamesResponse.fetching());
    const data = await lobbyController.getPreLobbyGames(value);
    this.setPreLobbyGamesResponse(this.preLobbyGamesResponse.fetched(data));
    markLaunchStep('preLobby');
  }

  public generateLaunchUrl(data: LaunchData): string {

    const {
      mode, partnerId, userId, currency, lobbyId,
      currencySymbol, culture, playerExternalId, exitUrl
    } = data;

    const url = new URL(`${env.origin}/lobby/`);
    // const url = new URL(`https://localhost:3000/lobby`);

    url.searchParams.set('partnerId', `${partnerId}`);
    url.searchParams.set('currency', `${currency}`);
    url.searchParams.set('currencySymbol', `${decodeURIComponent(currencySymbol)}`);
    url.searchParams.set('culture', `${culture}`);
    url.searchParams.set('userId', `${userId}`);
    url.searchParams.set('playerExternalId', `${playerExternalId}`);
    url.searchParams.set('mode', `${GameModeName[mode]}`);
    url.searchParams.set('lobbyId', `${lobbyId}`);
    if (exitUrl) {
      url.searchParams.set('exitUrl', encodeURIComponent(exitUrl));
    }

    return url.toString();
  }
}
